// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth_title__RWWec {
  margin-bottom: 32px;
  color: #fff;
  font-size: 32px;
  line-height: 52px;
  font-weight: 500;
  text-align: center;
}

.auth_description__6QVLY {
  width: 100%;
  max-width: 444px;
  margin: 0 0 12px;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
}

.auth_success-message__ZR7fQ {
  max-width: 362px;
  margin: 4px 0 0;
}

.auth_form__9GN0V {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 360px;
  margin-top: 20px;
}

.auth_input-error__L0IEe {
  width: 100%;
  margin-top: 4px;
  padding: 0 8px;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
}
.auth_input-error__L0IEe .auth_input-error-prefix__XWTxB {
  margin: 0;
  padding: 0 20px;
}

.auth_link__9LFFA {
  font-size: inherit;
  line-height: 1.5;
  text-decoration: underline;
}

.auth_inputs__KcaT5 {
  width: 100%;
}

.auth_input__4yqAj {
  width: 100%;
}
.auth_input__4yqAj:not(:last-child) {
  margin-bottom: 12px;
}

.auth_margin__9PANG {
  margin-top: 12px;
}

.auth_text__C8i15 {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: #f5f5ff;
  padding: 0px 8px;
}

.auth_eye__pCK9z:hover path {
  fill: #000093;
}

.auth_button__cxFFd {
  width: 200px;
  margin: 56px 0 32px;
}

.auth_link__9LFFA {
  font-size: 14px;
}

@media screen and (max-width: 600px) {
  form {
    width: 100%;
  }
  .auth_button__cxFFd {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/auth.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAIF;;AADA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAIF;;AADA;EACE,gBAAA;EACA,eAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAIF;;AADA;EACE,WAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAIF;AAFE;EACE,SAAA;EACA,eAAA;AAIJ;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,WAAA;AAEF;AAAE;EACE,mBAAA;AAEJ;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cChFS;EDiFT,gBAAA;AACF;;AAII;EACE,aCjFK;ADgFX;;AAMA;EACE,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE;IACE,WAAA;EAHF;EAMA;IACE,WAAA;EAJF;AACF","sourcesContent":["@use './colors';\n@use './sizes';\n\n.title {\n  margin-bottom: 32px;\n  color: #fff;\n  font-size: 32px;\n  line-height: 52px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.description {\n  width: 100%;\n  max-width: 444px;\n  margin: 0 0 12px;\n  color: #fff;\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n  text-align: center;\n}\n\n.success-message {\n  max-width: 362px;\n  margin: 4px 0 0;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 360px;\n  margin-top: 20px;\n}\n\n.input-error {\n  width: 100%;\n  margin-top: 4px;\n  padding: 0 8px;\n  color: #fff;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n\n  .input-error-prefix {\n    margin: 0;\n    padding: 0 20px;\n  }\n}\n\n\n.link{\n  font-size: inherit;\n  line-height: 1.5;\n  text-decoration: underline;\n}\n\n.inputs {\n  width: 100%;\n}\n\n.input {\n  width: 100%;\n\n  &:not(:last-child) {\n    margin-bottom: 12px;\n  }\n}\n\n.margin{\n  margin-top: 12px;\n}\n\n.text{\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n  color: colors.$primary1;\n  padding: 0px 8px;\n}\n\n.eye {\n  &:hover {\n    path {\n      fill: colors.$primary7;\n    }\n  }\n}\n\n.button {\n  width: 200px;\n  margin: 56px 0 32px;\n}\n\n.link {\n  font-size: 14px;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  form {\n    width: 100%;\n  }\n\n  .button {\n    width: 100%;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"title": `auth_title__RWWec`,
	"description": `auth_description__6QVLY`,
	"success-message": `auth_success-message__ZR7fQ`,
	"form": `auth_form__9GN0V`,
	"input-error": `auth_input-error__L0IEe`,
	"input-error-prefix": `auth_input-error-prefix__XWTxB`,
	"link": `auth_link__9LFFA`,
	"inputs": `auth_inputs__KcaT5`,
	"input": `auth_input__4yqAj`,
	"margin": `auth_margin__9PANG`,
	"text": `auth_text__C8i15`,
	"eye": `auth_eye__pCK9z`,
	"button": `auth_button__cxFFd`
};
export default ___CSS_LOADER_EXPORT___;
